import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import DatePicker, {registerLocale, setDefaultLocale} from "react-datepicker";

import {error, FORM, info, infoMsg, saveMsg, selectOption, success, updateMsg} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {seasonService} from "../../../jwt/_services/clasificator/seasonService";
import Switch from "react-bootstrap-switch";
import Select from "react-select";
import {typeSeasonProvider} from "../../../providers/typeSeasonProvider";
import moment from "moment";
import es from 'date-fns/locale/es';
import {utilHelper} from "../../../jwt/_helpers";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {TT_HISTORY} from "../../../components/i18n/toolTips";

registerLocale('es', es)

export default function SeasonForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableSelects, setDisableSelects] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);

    const [viewMode, setViewMode] = useState(props?.viewMode);
    const [showEditButton, setShowEditButton] = useState(props?.showEditButton);
    const [showSaveButton, setShowSaveButton] = useState(props?.viewMode === undefined);
    const [tdtProps] = useState(!!props?.tdtProps);


    const [status, setStatus] = useState(editMode ? props.item?.status : true);
    const [typeSeason, setTypeSeason] = useState(null);
    const [typeSeasonOptions, setTypeSeasonOptions] = useState([]);
    const [startDate, setStartDate] = useState(editMode ? utilHelper.dateSeasonFormatter(props.item?.startDate) : (props.item?.startDate !== undefined ? utilHelper.dateSeasonFormatter(props.item?.startDate) : new Date()));
    const [endDate, setEndDate] = useState(editMode ? utilHelper.dateSeasonFormatter(props.item?.endDate) : (props.item?.endDate !== undefined ? utilHelper.dateSeasonFormatter(props.item?.endDate) : new Date()));

    const [showModal, setShowModal] = useState(true);
    const modalRef = useRef(null);

    useEffect(() => {
        setLoading(true);

        if (viewMode !== undefined) {
            setDisableInputs(true);
        }

        typeSeasonProvider.getOptions()
            .then(result => {
                if (result){
                    setTypeSeasonOptions(result);
                }
                if (props.item?.typeSeason) {
                    typeSeasonProvider.getItem(props.item?.typeSeason?.id)
                        .then(data => {
                            setLoading(false);
                            setTypeSeason(data);
                        });
                } else {
                    setLoading(false);
                }
            })
            .catch(_ => {
                setLoading(false);
            })

    }, []);


    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            endDate: savedData?.endDate,
            startDate: savedData?.startDate,
            status: savedData?.status,
            typeSeason: savedData?.typeSeason,
        }
    });

    const onSubmit = (data, _) => {
        if (typeSeason == null) {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const dataRequest = {
            id: data.id,
            name: data.name,
            startDate: moment(startDate).format('DD/MM'),
            endDate: moment(endDate).format('DD/MM'),
            // Booleans
            status: status,
            // Objetos
            typeSeason: typeSeason,
        };

        if (!editMode) {
            //Save
            return seasonService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return seasonService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);

                    if (viewMode !== undefined) {
                        props.setStatusAfterEdit();
                    }

                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setDisableSelects(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setTypeSeason(null)
        setEditMode(false);
        setDisableInputs(false);
        setDisableSelects(false);
        setSaveSuccess(false);
        setStatus(true);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        setDisableSelects(true);

        if (viewMode) {
            setViewMode(false);
            setShowEditButton(false);
            setShowSaveButton(true);
            props.setEdit();
        }
    }

    setDefaultLocale('es');

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const statusChange = () => {
        setStatus(!status);
    }

    const onSeasonChange = (value) => {
        setTypeSeason(value);
    }

    const getClassName = (fieldName) => {
        if (tdtProps === undefined || tdtProps?.changedFields === undefined || tdtProps?.action === undefined)
            return '';

        if (tdtProps?.changedFields?.toString().includes(fieldName)) {
            switch (tdtProps?.action) {
                case 'CREATE' :
                    return 'tdt_viewer_lbl_new';
                case 'UPDATE' :
                    return 'tdt_viewer_lbl_edited';
                case 'DELETE' :
                    return 'tdt_viewer_lbl_deleted';
                default :
                    return '';
            }
        } else
            return '';
    }

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                <div className="float-right">
                    {
                        showEditButton ? <ButtonEdit onClick={beginEdit}/> : <div/>
                    }
                    {
                        editMode && <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    }
                </div>

            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="id" name="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Firebase ID</Label>
                                <Input type="uid" name="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label className={getClassName(('startDate'))}>Desde</Label>
                                <DatePicker
                                    inline
                                    dateFormat={"DD/MM"}
                                    showMonthDropdown={true}
                                    showYearDropdown={false}
                                    scrollableYearDropdown={false}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selected={startDate}
                                    onChange={date => setStartDate(date)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label className={getClassName(('endDate'))}>Hasta</Label>
                                <DatePicker
                                    inline
                                    dateFormat={"DD/MM"}
                                    showMonthDropdown={true}
                                    showYearDropdown={false}
                                    scrollableYearDropdown={false}
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                    selected={endDate}
                                    onChange={date => setEndDate(date)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className={getClassName(('typeSeason'))}>Tipo de temporada</Label>
                                        <br/>
                                        <Select
                                            value={typeSeason}
                                            options={typeSeasonOptions}
                                            onChange={onSeasonChange}
                                            isDisabled={disableSelects}
                                            innerRef={register}
                                            placeholder="Selecciona una opción"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className={getClassName(('status'))}>Activo</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={status}
                                                disabled={disableInputs}
                                                innerRef={register}
                                                onChange={statusChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                    {
                        !viewMode ?
                            <CardBody className="border-top">
                                {
                                    saveSuccess ?
                                        <div className="float-right">
                                            <ButtonNew onClick={() => {
                                                resetForm()
                                            }}/>
                                            <ButtonEdit onClick={() => {
                                                beginEdit()
                                            }}/>
                                            <ButtonCancel onClick={props.toggleParent}/>
                                        </div>
                                        : <div className="float-right">
                                            {showSaveButton ? <ButtonSubmit/> : <div/>}
                                            {viewMode === undefined ? <ButtonCancel onClick={props.toggleParent}/> : <div/>}
                                        </div>
                                }
                            </CardBody>
                            : <div/>
                    }
                </Form>
            </CardBody>
            {
                showModal &&
                <LogHistoryModal
                    ref={modalRef}
                    item={savedData}
                />
            }
        </Card>
    )
}